<template>
  <div id="app" :class="{ dark: isDark }">
    <v-header></v-header>
    <div class="container">
      <router-view />
    </div>
    <v-loading></v-loading>
    <!-- <v-sendmetrics :userID='userID' channel="deepbone" :targetUrl="logmapUrl"></v-sendmetrics> -->
  </div>
</template>
<script>
import VHeader from "@/components/nav";
import VLoading from "@/components/loading/searching";
import VSendmetrics from "@/components/sendMetrics/index";
import { logmapUrl, apiKeyUrl } from "./common.js";
import { getUrl } from "./utils/browser";
import axios from "axios";
// import Core from '@/core';
export default {
  name: "App",
  components: {
    VHeader,
    VLoading,
    VSendmetrics,
  },
  data() {
    return {
      isDark: false,
      // userID:Core.Data.getUser().id
      userID: "",
      logmapUrl: logmapUrl,
      apiKeyUrl: apiKeyUrl,
      interval: null,
      reporter: null,
    };
  },
  mounted() {
    this.isDark = localStorage.getItem("dark-style") == "yes" ? true : false;
    if(!localStorage.getItem("uuid")){
        localStorage.setItem("uuid",window.navigator.userAgent.replace(/[^\w]/gi, ''))//当前电脑浏览器的唯一标识)
    }
    // this.initAutoReport();
    // this.getApiKey();
    // this.interval = setInterval(() => {
    //   this.getApiKey();
    // }, 45000);
  },
  methods: {
    initAutoReport() {
      const reporter = new this.$AutoReport(
        "deepbone",
        this.logmapUrl,
        this.apiKeyUrl,
        "guest"
      );
      this.reporter = reporter;
      reporter.init(this.initOkEvent);
    },
    initOkEvent(e) {
      console.log(e);
    },
    getApiKey() {
      axios({
        method: "POST",
        url: apiKeyUrl,
        data: {
          channel: "deepbone",
        },
        headers: {
          "Content-Type": "application/json",
        },
      }).then((res) => {
        let key = res.data?.data;
        localStorage.setItem("api-key", key);
      });
    },
    clearInterval() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    },
  },
  watch: {
    $route: function (to, from) {
      let preUrl = from.fullPath == "/" ? "直接访问" : getUrl() + from.fullPath;
      //   this.$reporter.updatePreUrl(preUrl);
      console.log(preUrl)
      this.$reporter.sendPageOpenEvent(preUrl);
      //没有使用插件的pageopen事件，因此需要手动更新preUrl
      this.$bus.$emit("loading", false);
    },
  },
  beforeDestroyed() {
    sessionStorage.removeItem("preUrl");
    // this.clearInterval();
    this.$reporter.destroy();
  },
};
</script>
<style lang="css">
@import url("./assets/style/reset.css");
@import url("./assets/style/base.css");
@import url("./assets/style/dark.css");
#app {
  /* margin-top: 60px; */
}
.container {
  position: relative;
  min-height: 600px;
  margin-top: 60px;
  /* padding: 0 48px 60px; */
  background: linear-gradient(180deg, #ffffff 0%, #f5f5f5 100%);
}
.wrapper {
  display: flex;
  justify-content: space-around;
  position: relative;
  padding: 35px 48px 60px;
  /* min-height: 600px; */
}
</style>
